export default
    {
        // url: this.$store.state.http.provs.YYYY,
        listContratos:'/provs/listContratos',
        listEval:'/provs/listEval',
        listProv: "/provs/listProv",

        guardaContrato:"/provs/guardaContrato",
        guardaEval:'/provs/guardaEval',
        guardaProv: "/provs/guardaProv",

        getContrato:'/provs/getContrato',
    }
